// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"ffed0be0","198":"177e23c4","498":"a8606ed9","572":"f05f6636","703":"9ca2eddd","707":"9d1ee12b","712":"7ec0af99","875":"8e5f13c4","879":"b16d50f3","934":"1a97a746"}[chunkId] + ".chunk.js";
};